'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFiling = function IoFiling(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.8 10.1c0.9 0 1.5 0 1.5 1.5v2.2h-22.5v-2.2c0-1.5 0.6-1.5 1.5-1.5h19.5z m-3.8-2.6c1 0 1.5 0.1 1.5 1.5h-15c0-1.4 0.5-1.5 1.6-1.5h11.9z m7.8 5.8c1 0.6 1.3 1.3 1.1 3.2l-1.3 14.4c-0.3 1.6-1.3 1.6-1.9 1.6h-23.4c-0.6 0-1.6 0-1.9-1.6l-1.3-14.5c-0.3-2 0.1-2.4 1.2-3.1l1.1-0.8v2.5h25.1v-2.5z' })
        )
    );
};

exports.default = IoFiling;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/filing.js
// module id = 2023
// module chunks = 0